import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
//import App1 from './App1'
import reportWebVitals from './reportWebVitals'
import Context from './Context/Context'
import LineContext from './LineContext/Context'
import APICONTEXT from './CommonAPiContext/context'
import { AuthProvider } from './Context/authContext'
import {BrowserRouter as Router} from 'react-router-dom'
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
   <Router>
    {/* Auth context provider checks token validity and refresh 5 min before expiration */}
   <AuthProvider>
    <APICONTEXT>
    <LineContext>
      <Context>
        <App />
      </Context>
    </LineContext>
    </APICONTEXT>
    </AuthProvider>
   </Router>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
